import { _APP_CONFIG } from "../../core/config/AppConfig";
import { IAgendaEvent } from "../../ui/panelCard/Grupo/GruposAgenda";
import { DataDRequest } from "../DRequest";
import { Entidad } from "../Entidad";
import { DataModuloMain } from "../ModuloMain";
import { DataRequestWKList } from "../util/DRequestWKList";
import { DataUtil } from "../util/Util";
import { _DICC_ASIGNACION_GRUPO_ALUMNOS } from "./HorarioAlumno";

import CDia = Entidad.CDiaSemanal;
import IEscuela = Entidad.IEscuela;
import IGrupo = Entidad.IGrupo;

export const _DICC_GRUPO: Map<number, IGrupo> = new Map();

const REQUESTID = Entidad.CTipoRequest.Grupo;
const URL_SVCGRUPO = _APP_CONFIG.URL_RSTV2 + "grupo/";

export function _SvGrupoObtenerLista(escuelas: IEscuela[]): DataRequestWKList<IEscuela, IGrupo> {
    const url = URL_SVCGRUPO + "ObtenerListaV2";

    return new DataRequestWKList({
        iterable: escuelas,
        individualRequest: async ({ IdKinder }) => {
            const currentDateStr = await DataUtil._GetMaxDate(REQUESTID, IdKinder);
            const params = {
                "IdOrganizacion": DataUtil._Usuario.IdOrganizacion,
                "IdEscuela": IdKinder,
                "Modificacion": currentDateStr
            }
            return () => DataDRequest._Request4List(url, "GET", params, REQUESTID, IdKinder, { use: true });
        }
    })
}

export async function _SvGrupoNuevo(grupo: Pick<IGrupo, "Nombre" | "IdKinder" | "IdEscolaridad" | "IdNivel" | "EsPrincipal">) {
    const url = URL_SVCGRUPO + "NuevoGrupoV2";
    const params = {
        "IdOrganizacion": DataUtil._Usuario.IdOrganizacion,
        "IdUsuario": DataUtil._Usuario.IdUsuario,
        "Nombre": grupo.Nombre,
        "IdEscuela": grupo.IdKinder,
        "IdEscolaridad": grupo.IdEscolaridad,
        "IdGrado": grupo.IdNivel,
        "EsPrincipal": grupo.EsPrincipal,
    }

    return DataDRequest._Request5(url, "POST", params, REQUESTID);
}

/**
 * @param idGrado == EntidadGrupo.IdNivel
 */
export function _SvGrupoActualizarInfo(idGrupo: number, nombre: string, idGrado: number, idEscolaridad: number, esPrincipal: boolean) {
    const url = URL_SVCGRUPO + "ActualizarInfoV2";
    const params = {
        "IdUsuario": DataUtil._Usuario.IdUsuario,
        "IdGrupo": idGrupo,
        "IdGrado": idGrado,
        "IdEscolaridad": idEscolaridad,
        "Nombre": nombre,
        "EsPrincipal": esPrincipal
    }

    return DataDRequest._Request5(url, "POST", params, REQUESTID);
}

interface IActualizaHrOperacionResponse {
    IdAlumno: number;
    IdGrupo: number;
    IdHorario: number;
    // Valido: boolean;
}

export function _SvGrupoActualizarHorarioOperacion(idGrupo: number, horarios: Entidad.IHorarioDia[]): Promise<DataDRequest.IResultadoPeticion<IActualizaHrOperacionResponse[]>> {
    var url = URL_SVCGRUPO + "ActualizarHrOperacion"; //"AdminJS/Grupo/ActualizarGrupoV3"; // "Grupo/ActualizarGrupo";

    const params = {
        "IdUsuario": DataUtil._Usuario.IdUsuario,
        "IdGrupo": idGrupo,

        "LunesEntrada": horarios?.find(d => d.IdDia == CDia.Lunes)?.Entrada || null, // "2020-01-01T13:00:00.000Z",
        "LunesSalida": horarios?.find(d => d.IdDia == CDia.Lunes)?.Salida || null,
        "MartesEntrada": horarios?.find(d => d.IdDia == CDia.Martes)?.Entrada || null,
        "MartesSalida": horarios?.find(d => d.IdDia == CDia.Martes)?.Salida || null,
        "MiercolesEntrada": horarios?.find(d => d.IdDia == CDia.Miercoles)?.Entrada || null,
        "MiercolesSalida": horarios?.find(d => d.IdDia == CDia.Miercoles)?.Salida || null,
        "JuevesEntrada": horarios?.find(d => d.IdDia == CDia.Jueves)?.Entrada || null,
        "JuevesSalida": horarios?.find(d => d.IdDia == CDia.Jueves)?.Salida || null,
        "ViernesEntrada": horarios?.find(d => d.IdDia == CDia.Viernes)?.Entrada || null,
        "ViernesSalida": horarios?.find(d => d.IdDia == CDia.Viernes)?.Salida || null,
        "SabadoEntrada": horarios?.find(d => d.IdDia == CDia.Sabado)?.Entrada || null,
        "SabadoSalida": horarios?.find(d => d.IdDia == CDia.Sabado)?.Salida || null,
        "DomingoEntrada": horarios?.find(d => d.IdDia == CDia.Domingo)?.Entrada || null,
        "DomingoSalida": horarios?.find(d => d.IdDia == CDia.Domingo)?.Salida || null,
    }

    return new Promise(function (resolve, reject) {
        DataDRequest._Request(url, "POST", params, (result: DataDRequest.IResultadoPeticion<IActualizaHrOperacionResponse[]>) => {
            resolve({
                Resultado: (result?.Resultado || -100),
                Data: result?.Data,
                TipoRequest: REQUESTID
            });
        })
    })
}

export function _SvGrupoEliminarGrupo(idGrupo: number) {
    const url = URL_SVCGRUPO + "EliminarGrupoV2";
    const params = {
        "IdGrupo": idGrupo,
        "IdUsuario": DataUtil._Usuario.IdUsuario
    };

    return DataDRequest._Request5(url, "POST", params, REQUESTID);
}

export interface IGrupoCargaMasivaV2 extends Pick<IGrupo, "Nombre" | "EsPrincipal"> { }
export function _SvGrupoCargaMasiva(idEscuela: number, idEscolaridad: number, idGrado: number, grupos: IGrupoCargaMasivaV2[]) {
    const url = URL_SVCGRUPO + "GruposCargaMasivaV2";
    const params = {
        "IdOrganizacion": DataUtil._Usuario.IdOrganizacion,
        "IdUsuario": DataUtil._Usuario.IdUsuario,
        "IdEscuela": idEscuela,
        "IdEscolaridad": idEscolaridad,
        "IdGrado": idGrado,
        "Grupos": grupos
    };

    return DataDRequest._Request5(url, "POST", params, REQUESTID);
}

// /** Resultado
//  * * (> 0) - Exitoso
//  * * (-1) - Grupo no encontrada
//  * * (-2) - Calendario no configurado (no vinculado)
//  */
// export async function _AsignarCalendarioGoogle(idGrupo: number): Promise<DataDRequest.IResultadoPeticion<undefined>> {
//     const url = URL_SVCGRUPO + "AsignarCalendario";
//     const params = {
//         "IdUsuario": DataUtil._Usuario.IdUsuario,
//         "IdGrupo": idGrupo
//     }

//     return new Promise(async (resolve) => {
//         await DataDRequest._Request2<{ Resultado: number }>(url, "POST", params)
//             .then((res) => {
//                 resolve({
//                     Resultado: res.data?.Resultado ? res.data.Resultado : -10,
//                     TipoRequest: REQUESTID
//                 })
//             })
//     })
// }

// ********************************************************************************
// Asignaciones Grupos-Maestros
// ********************************************************************************

export async function _SvGruposObtenerMaestros(idGrupo: number) {
    const url = URL_SVCGRUPO + "ObtenerMaestros";
    const params = {
        "IdGrupo": idGrupo
    }

    return DataDRequest._Request5<Entidad.IMaestroGrupo[]>(url, "GET", params, Entidad.CTipoRequest.Grupo);
}

export async function _SvGrupoObtenerEventosCalendarios(idEscuela: number, idGrupo: number, startDate: string, endDate: string) {
    const url = URL_SVCGRUPO + "ObtenerEventosCalendario";
    const params = {
        "IdEscuela": idEscuela,
        "IdGrupo": idGrupo,
        "Inicio": startDate,
        "Fin": endDate,
    }

    return DataDRequest._Request5<IAgendaEvent[]>(url, "GET", params)
}

interface IMaestraAgendaTareaEvent extends IAgendaEvent {
    IdMaestra?: number;
}

export async function _SvGrupoObtenerMaestrosAgendaTareas(idMaestros: number[], startDate: string, endDate: string) {
    const url = URL_SVCGRUPO + "ObtenerMaestrosAgendaTareas";
    const params = {
        "IdMaestros": idMaestros,
        "Inicio": startDate,
        "Fin": endDate,
    }

    return DataDRequest._Request5<IMaestraAgendaTareaEvent[]>(url, "GET", params);
}

export async function _SvEliminarAgendaTarea(agendaTarea: IAgendaEvent) {
    const url = URL_SVCGRUPO + "EliminarTareaDeAgenda";
    const params = {
        "IdTarea": agendaTarea.Id,
        "IdUsuario": DataUtil._Usuario.IdUsuario,
    }

    return DataDRequest._Request5(url, "POST", params);
}

export async function _SvAgregarAgendaTarea(agendaTarea: IAgendaEvent, idKinder: number) {
    const url = URL_SVCGRUPO + "AgregarTareaDeAgenda";
    const params = {
        "IdKinder": idKinder,
        "IdMaestra": agendaTarea.IdOrigin,
        "IdUsuario": DataUtil._Usuario.IdUsuario,
        "Nombre": agendaTarea.Name,
        "Descripcion": "",
        "Inicio": agendaTarea.StrStart,
        "Fin": agendaTarea.StrEnd,
    }

    return DataDRequest._Request5(url, "POST", params);
}

export async function _SvEditarAgendaTarea(agendaTarea: IAgendaEvent) {
    const url = URL_SVCGRUPO + "EditarTareaDeAgenda";
    const params = {
        "IdTarea": agendaTarea.Id,
        "Nombre": agendaTarea.Name,
        "Inicio": agendaTarea.StrStart,
        "Fin": agendaTarea.StrEnd,
        "IdUsuario": DataUtil._Usuario.IdUsuario,
    }

    return DataDRequest._Request5(url, "POST", params);
}

export async function _SvGrupoAsignarMaestro(idGrupo: number, idMaestro: number) {
    const url = URL_SVCGRUPO + "AsignarMaestro";
    const params = {
        "IdGrupo": idGrupo,
        "IdMaestro": idMaestro,
        "IdUsuario": DataUtil._Usuario.IdUsuario,
        "IdOrganizacion": DataUtil._Usuario.IdOrganizacion
    }

    return DataDRequest._Request5(url, "POST", params, Entidad.CTipoRequest.Grupo);
}

export async function _SvGrupoFinalizarAsignacionMaestro(idAsignacion: number) {
    const url = URL_SVCGRUPO + "FinalizarAsignacionMaestro";
    const params = {
        "IdAsignacion": idAsignacion,
        "IdUsuario": DataUtil._Usuario.IdUsuario
    }

    return DataDRequest._Request5(url, "POST", params, Entidad.CTipoRequest.Grupo);
}

// ********************************************************************************
// LOCAL DATA
// ********************************************************************************

/** @returns Map<IdAlumno, IChild> */
export function _LOCALDATA_GetAlumnosEnGrupo(idGrupo: number, includeStudensNoFounded = false) {
    let asignacionesGrupo = _DICC_ASIGNACION_GRUPO_ALUMNOS.get(idGrupo);
    let alumnosMap = new Map<number, Entidad.IAlumno>();
    // let alumnosNoEncontrados = [];
    asignacionesGrupo?.forEach(asignacionH => {
        let alumno = DataModuloMain._GetReqDataMapById(Entidad.CTipoRequest.Alumno).get(asignacionH.IdNinio);
        if (alumno) {
            alumnosMap.set(asignacionH.IdNinio, alumno);
        } else {
            if (includeStudensNoFounded) {
                alumnosMap.set(asignacionH.IdNinio, null);
            }
            // alumnosNoEncontrados.push(asignacionH.IdNinio);
        }
    });
    // if (alumnosNoEncontrados.length) {
    //     console.warn("-d", ">> LOCALDATA -> Grupo:", idGrupo, ", Alumnos no encontrados:", alumnosNoEncontrados);
    // }
    return alumnosMap;
}
